import React from 'react';

import {
	PAGE_HEADER_LOGO_COL_STYLE,
	PAGE_HEADER_NAME_STYLE,
	PAGE_HEADER_OUTER_STYLE,
	PAGE_HEADER_TEXT_COL_STYLE,
	PAGE_HEADER_THUMBNAIL_COL_STYLE,
	PAGE_HEADER_THUMBNAIL_IMG_STYLE,
	PAGE_HEADER_TITLE_STYLE,
	RTA_LOGO_SVG_STYLE
} from './blueprint-page-header.styles';
import { EditableText } from './editable-text';
import { useBlueprintOverrides } from './blueprint-overrides-context';
import { usePageByNumber } from './blueprint-pages-context';

export type BlueprintPageHeaderProps = {
	title: string;
	pageNumber: number;
	customerName?: string;
	layoutDescription?: string;
	designerName?: string;
	creationDate?: string;
	threeDImageUrl?: string;
	showThumbnail?: boolean;
};

const RtaLogo = (): React.ReactElement => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1474.89 633.36" style={RTA_LOGO_SVG_STYLE}>
		<g>
			<g>
				<path fill="#282f36" d="m212.33,351.39h-57.78v165.39H0V1.12h221.37c39.54,0,72.71,4.46,99.47,13.36,26.77,8.91,48.34,20.94,64.74,36.11,16.4,15.17,28.09,33.11,35.04,53.81,7,20.71,10.5,42.61,10.5,65.72,0,34.67-6.62,64.28-19.86,88.83-13.25,24.55-31.9,44.54-55.97,59.94,0,0-49.25,28.43-143,32.5"/>
				<polyline fill="#282f36" points="385.29 379.7 462.21 516.07 294.66 516.07 229.71 386.77"/>
				<polygon fill="#e6e7e8" points="619.66 218.74 619.66 516.77 783.6 516.77 783.6 163.29 619.66 218.74"/>
				<polygon fill="#282f36" points="475.94 1.12 475.94 141.95 619.66 141.95 619.66 142.02 783.6 142.02 783.6 141.95 927.32 141.95 927.32 1.12 475.94 1.12"/>
				<polygon fill="#282f36" points="619.66 218.74 619.66 516.77 783.6 516.77 783.6 163.29 619.66 218.74"/>
			</g>
			<g>
				<polygon fill="#282f36" points="1314.54 242.07 1174.77 0 1025.58 258.39 876.39 516.8 1122.18 516.8 1314.54 242.07"/>
				<polygon fill="#282f36" points="1199.53 516.8 1474.89 515.07 1349.79 302.32 1199.53 516.8"/>
			</g>
		</g>
		<g>
			<path fill="#3cc6f4" d="m414.94,633.25c-5.43,0-10.38-.95-14.85-2.86-4.47-1.91-8.3-4.57-11.5-7.97-3.19-3.41-5.67-7.43-7.42-12.04-1.76-4.62-2.64-9.64-2.64-15.07s.88-10.45,2.64-15.07,4.23-8.63,7.42-12.04c3.19-3.41,7.02-6.07,11.5-7.97,4.47-1.91,9.42-2.86,14.85-2.86s10.38.95,14.85,2.86c4.47,1.91,8.3,4.56,11.5,7.97,3.19,3.41,5.66,7.42,7.42,12.04,1.76,4.62,2.64,9.64,2.64,15.07s-.88,10.45-2.64,15.07c-1.76,4.62-4.23,8.63-7.42,12.04-3.19,3.41-7.02,6.07-11.5,7.97-4.47,1.91-9.42,2.86-14.85,2.86Zm0-8.14c4.11,0,7.81-.75,11.11-2.25,3.3-1.5,6.12-3.59,8.47-6.27,2.35-2.68,4.16-5.83,5.44-9.46,1.28-3.63,1.93-7.57,1.93-11.83s-.64-8.21-1.93-11.88c-1.28-3.67-3.1-6.82-5.44-9.46-2.35-2.64-5.17-4.71-8.47-6.21-3.3-1.5-7-2.26-11.11-2.26s-7.83.75-11.17,2.26c-3.34,1.5-6.18,3.57-8.52,6.21-2.35,2.64-4.14,5.79-5.39,9.46-1.25,3.67-1.87,7.63-1.87,11.88s.62,8.2,1.87,11.83c1.25,3.63,3.04,6.78,5.39,9.46,2.35,2.68,5.19,4.77,8.52,6.27,3.34,1.5,7.06,2.25,11.17,2.25Z"/>
			<path fill="#3cc6f4" d="m510.97,633.25c-4.99,0-9.35-.71-13.09-2.15-3.74-1.43-6.86-3.43-9.35-6-2.49-2.57-4.36-5.68-5.61-9.35-1.25-3.67-1.87-7.77-1.87-12.32v-44.88h9.13v44.66c0,6.75,1.76,12.04,5.28,16,3.52,3.92,8.69,5.88,15.51,5.88s11.99-1.96,15.51-5.88c3.52-3.92,5.28-9.26,5.28-16v-44.66h9.13v44.77c0,4.55-.62,8.67-1.87,12.38-1.25,3.7-3.12,6.86-5.61,9.46-2.49,2.6-5.61,4.6-9.35,6-3.74,1.39-8.1,2.09-13.09,2.09Z"/>
			<path fill="#3cc6f4" d="m591.6,631.93v-65.23h-23.21v-8.14h55.66v8.14h-23.32v65.23h-9.13Z"/>
			<path fill="#3cc6f4" d="m651.55,631.93v-73.37h25.08c5.72,0,10.89.94,15.51,2.8,4.62,1.87,8.56,4.46,11.83,7.76,3.26,3.3,5.79,7.19,7.59,11.66,1.8,4.47,2.69,9.31,2.69,14.52s-.9,10.05-2.69,14.52c-1.8,4.47-4.33,8.34-7.59,11.61-3.26,3.26-7.21,5.83-11.83,7.7s-9.79,2.8-15.51,2.8h-25.08Zm25.04-8.14c4.47,0,8.45-.75,11.94-2.25,3.48-1.5,6.43-3.54,8.85-6.11,2.42-2.57,4.25-5.57,5.5-9.02,1.25-3.45,1.87-7.15,1.87-11.11s-.62-7.68-1.87-11.17c-1.25-3.48-3.06-6.51-5.45-9.08-2.38-2.57-5.32-4.6-8.8-6.1-3.48-1.5-7.5-2.26-12.04-2.26h-15.95v57.09h15.95Z"/>
			<path fill="#3cc6f4" d="m777.39,633.25c-5.43,0-10.38-.95-14.85-2.86-4.47-1.91-8.3-4.57-11.5-7.97-3.19-3.41-5.67-7.43-7.42-12.04-1.76-4.62-2.64-9.64-2.64-15.07s.88-10.45,2.64-15.07,4.23-8.63,7.42-12.04c3.19-3.41,7.02-6.07,11.5-7.97,4.47-1.91,9.42-2.86,14.85-2.86s10.38.95,14.85,2.86c4.47,1.91,8.3,4.56,11.5,7.97,3.19,3.41,5.66,7.42,7.42,12.04,1.76,4.62,2.64,9.64,2.64,15.07s-.88,10.45-2.64,15.07c-1.76,4.62-4.23,8.63-7.42,12.04-3.19,3.41-7.02,6.07-11.5,7.97-4.47,1.91-9.42,2.86-14.85,2.86Zm0-8.14c4.11,0,7.81-.75,11.11-2.25,3.3-1.5,6.12-3.59,8.47-6.27,2.35-2.68,4.16-5.83,5.44-9.46,1.28-3.63,1.93-7.57,1.93-11.83s-.64-8.21-1.93-11.88c-1.28-3.67-3.1-6.82-5.44-9.46-2.35-2.64-5.17-4.71-8.47-6.21-3.3-1.5-7-2.26-11.11-2.26s-7.83.75-11.17,2.26c-3.34,1.5-6.18,3.57-8.52,6.21-2.35,2.64-4.14,5.79-5.39,9.46-1.25,3.67-1.87,7.63-1.87,11.88s.62,8.2,1.87,11.83c1.25,3.63,3.04,6.78,5.39,9.46,2.35,2.68,5.19,4.77,8.52,6.27,3.34,1.5,7.06,2.25,11.17,2.25Z"/>
			<path fill="#3cc6f4" d="m876.94,633.25c-5.43,0-10.38-.95-14.85-2.86-4.47-1.91-8.3-4.57-11.5-7.97-3.19-3.41-5.67-7.43-7.42-12.04-1.76-4.62-2.64-9.64-2.64-15.07s.88-10.45,2.64-15.07,4.23-8.63,7.42-12.04c3.19-3.41,7.02-6.07,11.5-7.97,4.47-1.91,9.42-2.86,14.85-2.86s10.38.95,14.85,2.86c4.47,1.91,8.3,4.56,11.5,7.97,3.19,3.41,5.66,7.42,7.42,12.04,1.76,4.62,2.64,9.64,2.64,15.07s-.88,10.45-2.64,15.07c-1.76,4.62-4.23,8.63-7.42,12.04-3.19,3.41-7.02,6.07-11.5,7.97-4.47,1.91-9.42,2.86-14.85,2.86Zm0-8.14c4.11,0,7.81-.75,11.11-2.25,3.3-1.5,6.12-3.59,8.47-6.27,2.35-2.68,4.16-5.83,5.44-9.46,1.28-3.63,1.93-7.57,1.93-11.83s-.64-8.21-1.93-11.88c-1.28-3.67-3.1-6.82-5.44-9.46-2.35-2.64-5.17-4.71-8.47-6.21-3.3-1.5-7-2.26-11.11-2.26s-7.83.75-11.17,2.26c-3.34,1.5-6.18,3.57-8.52,6.21-2.35,2.64-4.14,5.79-5.39,9.46-1.25,3.67-1.87,7.63-1.87,11.88s.62,8.2,1.87,11.83c1.25,3.63,3.04,6.78,5.39,9.46,2.35,2.68,5.19,4.77,8.52,6.27,3.34,1.5,7.06,2.25,11.17,2.25Z"/>
			<path fill="#3cc6f4" d="m985.51,631.93l-18.7-29.15h-14.63v29.15h-9.13v-73.37h29.48c3.37,0,6.45.51,9.24,1.54,2.79,1.03,5.21,2.51,7.26,4.46,2.05,1.94,3.65,4.27,4.79,6.98,1.14,2.71,1.7,5.75,1.7,9.13s-.51,6.23-1.54,8.8c-1.03,2.57-2.42,4.73-4.18,6.49-1.76,1.76-3.79,3.15-6.1,4.18-2.31,1.03-4.71,1.65-7.21,1.87l19.8,29.93h-10.78Zm-14.04-37.29c4.4,0,7.94-1.3,10.62-3.89,2.68-2.59,4.01-5.97,4.01-10.14s-1.34-7.52-4.01-10.08c-2.68-2.56-6.22-3.83-10.62-3.83h-19.25v27.94h19.25Z"/>
			<path fill="#3cc6f4" d="m1069.1,631.93v-73.37h9.13v65.23h34.1v8.14h-43.23Z"/>
			<path fill="#3cc6f4" d="m1140.6,631.93v-73.37h9.13v73.37h-9.13Z"/>
			<path fill="#3cc6f4" d="m1204.18,631.93l-29.48-73.37h10.45l24.75,63.36,24.75-63.36h10.45l-29.59,73.37h-11.33Z"/>
			<path fill="#3cc6f4" d="m1270.07,631.93v-73.37h9.13v73.37h-9.13Z"/>
			<path fill="#3cc6f4" d="m1363.68,631.93l-42.79-58.52v58.52h-9.13v-73.37h9.35l42.24,57.31v-57.31h9.13v73.37h-8.8Z"/>
			<path fill="#3cc6f4" d="m1439.8,633.36c-5.21,0-10.1-.92-14.69-2.75-4.58-1.83-8.58-4.42-11.99-7.75-3.41-3.34-6.1-7.33-8.08-11.99-1.98-4.66-2.97-9.84-2.97-15.56s.99-10.91,2.97-15.57c1.98-4.66,4.67-8.63,8.08-11.93s7.41-5.87,11.99-7.7c4.58-1.83,9.48-2.75,14.69-2.75,6.53,0,12.08,1.28,16.67,3.85,4.58,2.57,8.52,5.87,11.83,9.9l-7.26,4.51c-2.35-3.01-5.37-5.44-9.07-7.31-3.7-1.87-7.75-2.81-12.16-2.81-4.03,0-7.77.73-11.22,2.2-3.45,1.47-6.44,3.52-8.97,6.16-2.53,2.64-4.51,5.78-5.94,9.41-1.43,3.63-2.15,7.64-2.15,12.04s.72,8.32,2.15,11.99c1.43,3.67,3.41,6.82,5.94,9.46,2.53,2.64,5.52,4.71,8.97,6.21,3.45,1.5,7.19,2.25,11.22,2.25,2.2,0,4.29-.24,6.27-.71,1.98-.48,3.81-1.1,5.5-1.87,1.69-.77,3.21-1.63,4.56-2.58,1.36-.95,2.48-1.87,3.35-2.75v-14.96h-25.19v-8.14h34.32v26.51c-3.45,3.81-7.61,6.88-12.49,9.18-4.88,2.31-10.32,3.46-16.33,3.46Z"/>
		</g>
	</svg>
);

type LegacyHeaderDetails = {
	/** First line of the old combined block — the customer name. */
	name?: string;
	/** Remaining lines, rendered in place of the generated layout/designer/date lines. */
	rest: React.ReactNode;
};

/**
 * The customer name used to share one editable block (`header.details`) with the three detail
 * lines, so editing any of them flattened the whole block and destroyed the name's bold. Splits
 * a stored legacy value back apart on its first line so designs already carrying one recover
 * the bold instead of staying flat.
 */
const parseLegacyHeaderDetails = (legacyDetails: string | undefined): LegacyHeaderDetails | null => {
	if (legacyDetails === undefined) return null;

	const lines = legacyDetails.split('\n');

	return {
		// `||` not `??`: a blank first line must fall through to the real name rather than render empty.
		name: lines[0] || undefined,
		rest: lines.slice(1).map((text, i) => (
			<React.Fragment key={i}>
				{i > 0 && <br />}
				{text}
			</React.Fragment>
		))
	};
};

export const BlueprintPageHeader = (props: BlueprintPageHeaderProps): React.ReactElement => {
	const {
		title,
		pageNumber,
		customerName = '',
		layoutDescription = '',
		designerName = '',
		creationDate = '',
		threeDImageUrl,
		showThumbnail = false
	} = props;

	const page = usePageByNumber(pageNumber);
	const titleOverrideKey = `${page?.overrideScope ?? `page.${pageNumber}`}.header.title`;
	const legacyTitleOverrideKey = page?.legacyPageNumber === undefined
		? undefined
		: `header.title.${page.legacyPageNumber}`;

	const subDetailLines = [
		layoutDescription,
		designerName ? `Designer: ${designerName}` : '',
		creationDate ? `Creation Date: ${creationDate}` : ''
	].filter((text) => text);

	const { overrides } = useBlueprintOverrides();
	const legacy = parseLegacyHeaderDetails(overrides['header.details']);

	return (
		<div style={PAGE_HEADER_OUTER_STYLE}>
			{/* Left column: 3D thumbnail (empty on cover page) */}
			<div style={PAGE_HEADER_THUMBNAIL_COL_STYLE}>
				{showThumbnail && threeDImageUrl && (
					<img
						data-blueprint-render="true"
						src={threeDImageUrl}
						alt="3D Preview"
						style={PAGE_HEADER_THUMBNAIL_IMG_STYLE}
					/>
				)}
			</div>

			{/* Center: logo — sits at midpoint of the gap between thumbnail and text. */}
			<div style={PAGE_HEADER_LOGO_COL_STYLE}>
				<RtaLogo />
			</div>

			{/* Right column: customer info + page title — PDF headerSingleColumn + pullRight */}
			<div style={PAGE_HEADER_TEXT_COL_STYLE}>
				<EditableText overrideKey='header.customerName' style={PAGE_HEADER_NAME_STYLE}>
					{legacy?.name ?? customerName}
				</EditableText>
				<EditableText overrideKey='header.subDetails'>
					{legacy ? legacy.rest : subDetailLines.map((text, i) => (
						<React.Fragment key={i}>
							{i > 0 && <br />}
							{text}
						</React.Fragment>
					))}
				</EditableText>
				{title !== '' && (
					<EditableText overrideKey={titleOverrideKey} legacyOverrideKey={legacyTitleOverrideKey} style={PAGE_HEADER_TITLE_STYLE}>
						{title}
					</EditableText>
				)}
			</div>
		</div>
	);
};
